import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './modules/App.jsx';
import './styles/index.css';
import { authAPI } from './modules/utils/api.js';

function bootstrapTgOnce() {
  const tg = window?.Telegram?.WebApp;
  if (!tg) return false;
  try {
    tg.ready();
    tg.expand();
    if (typeof tg.setSwipeBehavior === 'function') {
      tg.setSwipeBehavior({ allow_vertical_swipe: false });
    } else if (typeof tg.disableVerticalSwipes === 'function') {
      tg.disableVerticalSwipes();
    }
    const tryLogin = () => {
      const initData = tg.initData || '';
      if (!initData) {
        setTimeout(tryLogin, 100);
        return;
      }
      authAPI.loginTelegram()
        .then((data) => {
          try {
            const token = data?.access_token || data?.accessToken || data?.token || '';
            const type = data?.token_type || data?.tokenType || 'Bearer';
            if (token) {
              localStorage.setItem('auth_access_token', token);
              localStorage.setItem('auth_token_type', type || 'Bearer');
              window.__authAccessToken = token;
              window.__authTokenType = type || 'Bearer';
            }
          } catch {}
        })
        .catch(() => {});
    };
    tryLogin();
    const hasCustomTheme = !!localStorage.getItem('theme');
    const isDark = tg.colorScheme === 'dark';
    if (!hasCustomTheme) {
      document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
    }
    if (typeof tg.onEvent === 'function') {
      tg.onEvent('themeChanged', () => {
        try {
          if (!localStorage.getItem('theme')) {
            const dark = tg.colorScheme === 'dark';
            document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
          }
        } catch {}
      });
    }
  } catch {}
  return true;
}

if (!bootstrapTgOnce()) {
  const startedAt = Date.now();
  const timer = setInterval(() => {
    if (bootstrapTgOnce()) {
      clearInterval(timer);
    } else if (Date.now() - startedAt > 15000) {
      clearInterval(timer);
    }
  }, 100);
}

let touchStartY = 0;
let isScrollable = false;

document.addEventListener('touchstart', (e) => {
  touchStartY = e.touches[0].clientY;
  const target = e.target;
  
  let element = target;
  isScrollable = false;
  
  while (element && element !== document.body) {
    const style = window.getComputedStyle(element);
    const overflowY = style.overflowY;
    
    if ((overflowY === 'auto' || overflowY === 'scroll') && element.scrollHeight > element.clientHeight) {
      isScrollable = true;
      
      if (element.scrollTop === 0) {
        break;
      }
      
      return;
    }
    element = element.parentElement;
  }
}, { passive: false });

document.addEventListener('touchmove', (e) => {
  const touchY = e.touches[0].clientY;
  const touchDelta = touchY - touchStartY;
  
  if (touchDelta > 0) {
    const target = e.target;
    let element = target;
    let atTop = true;
    
    while (element && element !== document.body) {
      const style = window.getComputedStyle(element);
      const overflowY = style.overflowY;
      
      if ((overflowY === 'auto' || overflowY === 'scroll') && element.scrollHeight > element.clientHeight) {
        if (element.scrollTop > 0) {
          atTop = false;
          break;
        }
      }
      element = element.parentElement;
    }
    
    if (atTop && touchDelta > 5) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
}, { passive: false });

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>
);
